export const ClinicCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',
  cursor: 'pointer',
  width: '100%',
  isSelected: (el, s) => s.root.selectedClinicId === s.id,
  '.isSelected': { borderColor: 'teal', background: 'teal.08' },
  onClick: (e, el, s) => s.root.update({ selectedClinic: s.name, selectedClinicId: s.id }),
  show: (el, s) => {
    const q = s.root.clinicFilter
    if (!q) return true
    const lower = q.toLowerCase()
    return s.name.toLowerCase().includes(lower) || s.district.toLowerCase().includes(lower)
  },
  CardTop: {
    flow: 'x', align: 'center space-between',
    ClinicName: { text: (el, s) => s.name, fontSize: 'Z', fontWeight: '600', color: 'inkText' },
    RatingRow: {
      flow: 'x', gap: 'X', align: 'center center',
      RatingStar: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' },
      RatingNum: { text: (el, s) => String(s.rating), fontSize: 'Z', fontWeight: '700', color: 'inkText' },
      ReviewNum: { text: (el, s) => '(' + s.reviews + ')', fontSize: 'Y', color: 'inkMuted' }
    }
  },
  CardMid: {
    flow: 'x', gap: 'Y',
    DistrictText: { text: (el, s) => s.district, fontSize: 'Y', color: 'teal', fontWeight: '500' },
    SepDot: { text: '{{ u00b72 | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    AddressText: { text: (el, s) => s.address, fontSize: 'Y', color: 'inkMuted' }
  },
  ClinicRating: {
    flow: 'x',
    gap: 'W',
    align: 'center flex-start',
    RatingStarIcon: { extends: 'Icon', icon: 'star', width: 'Y', height: 'Y', color: 'teal' },
    RatingAvg: { text: (el, s) => String(s.clinicRating || s.rating || '0'), fontSize: 'Y', fontWeight: '600', color: 'teal' },
    RatingLabel: { text: '{{ clinicAvgRating | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
  },

  CardServices: {
    flow: 'x', gap: 'Y', flexWrap: 'wrap',
    children: (el, s) => (s.services || []).map(sv => ({ label: sv })),
    childrenAs: 'state',
    childProps: {
      text: (el, s) => s.label,
      fontSize: 'Y',
      padding: 'X Y',
      round: 'Y',
      background: 'inkSurface',
      color: 'inkSubtle'
    }
  }
}
